export const DATA_SERVICE_URL = 'https://widget-data.service.elfsight.com/api';
